import { DeleteSweep } from '@mui/icons-material'
import { ListItemIcon, ListItemText, MenuItem } from '@mui/material'
import { useIntl } from 'react-intl'
import { ButtonLink } from '../../../../components/wrappers/Button'
import { TtoggleDrawerOnMobile } from '../../../../containers/Sidebar/Sidebar'
import { FeatureToggle } from '../../../../contexts/toggle-feature'
import { CACHE_PURGE_FEATURE_TOGGLE } from '../constants/purgeTargets'
import { useCanPurgeCache } from '../hooks/useCanPurgeCache'

interface MenuCacheManagementProps {
  pathname: string
  nested?: string
  toggleDrawerOnMobile: TtoggleDrawerOnMobile
}

export default function MenuCacheManagement({
  pathname,
  nested,
  toggleDrawerOnMobile,
}: MenuCacheManagementProps) {
  const { formatMessage } = useIntl()
  const canPurgeCache = useCanPurgeCache()

  if (!canPurgeCache) return null

  return (
    <FeatureToggle.On name={CACHE_PURGE_FEATURE_TOGGLE}>
      <div onClick={toggleDrawerOnMobile}>
        <MenuItem
          className={nested}
          component={ButtonLink}
          href="/casino/cache-management"
          selected={pathname.startsWith('/casino/cache-management')}
        >
          <ListItemIcon>
            <DeleteSweep />
          </ListItemIcon>
          <ListItemText
            primary={formatMessage({
              id: 'casino.submenu.cacheManagement.title',
            })}
          />
        </MenuItem>
      </div>
    </FeatureToggle.On>
  )
}
